import { useLantern, useSession } from "../hooks";
import { navigate } from "../router";
import { t } from "../i18n";

// Toasts are pop-ups for DMs and mentions that arrive in channels not in
// view; clicking one opens the message.
export function Toasts() {
  const session = useSession();
  const { toasts } = useLantern();
  if (toasts.length === 0) return null;
  return (
    <ul className="toasts" aria-live="polite" aria-label={t("New messages")}>
      {toasts.map((toast) => (
        <li key={toast.id}>
          <button
            className="toast"
            onClick={() => {
              navigate(toast.channelID && toast.messageID ? `/c/${toast.channelID}/m/${toast.messageID}` : "/inbox");
              session.dismissToast(toast.id);
            }}
          >
            <strong>{toast.title}</strong>
            <span>{toast.body}</span>
          </button>
          <button className="close" aria-label={t("Dismiss")} onClick={() => session.dismissToast(toast.id)}>
            ×
          </button>
        </li>
      ))}
    </ul>
  );
}
